module.exports = "/config.sma.json";